var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 mb-4"},[_c('Header'),_c('Form',{on:{"saved":_vm.loadData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }